import React from 'react';
import LibraryItemTile from '@/components/library-elements/library-item-tile';

export default function LibraryCategory({ locale, items }) {
	// Since we cannot know which items will be above or below the fold (ssr), we need to make an estimate.
	// That's why we eager-load the thumbnails for the first 5 items and lazy load to the rest
	const aboveTheFoldEstimate = 5;
	return (
		<div className="container pb-10">
			<div className="flex flex-wrap justify-center">
				{items.map((item, index) => (
					<LibraryItemTile key={item.id} locale={locale} item={item} lazyImg={index >= aboveTheFoldEstimate} />
				))}
			</div>
		</div>
	);
}
